import { ResultsActions } from './results.actions';
import { IResults } from '../interfaces';
import { IPayloadAction } from './session.actions';
import { ScannerActions } from '../scanner/scanner.actions';

function determineComputed(state: IResults) {
  return {
    ...state,
    errors: state.current
      .filter((r) => r.error)
      .map((r) => `${r.sortKey.split('-')[1]} - ${r.error}`),
    successful: state.current.filter((r) => r.status === 'success'),
    failures: state.current.filter((r) => r.error),
    processing: state.current.filter((r) => !r.error && r.status !== 'success'),
    hasSuccessful: state.current.filter((r) => r.status === 'success').length > 0,
    hasFailures: state.current.filter((r) => r.error).length > 0,
    hasProcessing: state.current.filter((r) => !r.error && r.status !== 'success').length > 0,
  };
}

function expireProcessing(result) {
  if (!result.error && result.status !== 'success') {
    return {
      ...result,
      error: 'some pages of this document could not be identified.',
    };
  } 
  return result;
  
}

export function resultsReducer(state: IResults, action: IPayloadAction) {
  switch (action.type) {
    case ScannerActions.RESET_SCANS:
      return determineComputed({
        ...state,
        current: [],
      });

    case ResultsActions.SET_RESULTS_DATA:
      return determineComputed({
        ...state,
        current: action.payload,
      });

    case ResultsActions.EXPIRE_PROCESSING_RESULTS:
      return determineComputed({
        ...state,
        current: state.current.map(expireProcessing),
      });

    default:
      return state;
  }
}
